import { takeLatest, put, call } from "redux-saga/effects";
import { setProjectBegin, setProjectSuccess, setProjectError } from "./slice";
import { fetchSIngleProjectAction, getRoles, selectProject } from "./actions";
import { setRolesSuccess } from "@store/userRoles/slice";
import { apiGet } from "api/callApi";

function* setProject(val) {
  yield put(setProjectBegin());
  try {
    const data = val.payload;
    if (data) {
      yield put(setProjectSuccess(data));
    } else {
      yield put(setProjectError());
    }
  } catch (error) {
    yield put(setProjectError(error));
  }
}

function* fetchProjectDetails(val) {
  yield put(setProjectBegin());
  try {
    const projectId = val.payload;

    const response = yield call(
      apiGet,
      `/v1/projects/single/${projectId}`,
      false
    );
    const projectData = response?.data?.[0];

    if (projectData?.id) {
      yield put(setProjectSuccess(projectData));
    } else {
      yield put(setProjectError("Project not found"));
    }
  } catch (error) {
    yield put(setProjectError(error));
  }
}

export function* watchsetProject() {
  yield takeLatest(selectProject.type, setProject);
  yield takeLatest(fetchSIngleProjectAction.type, fetchProjectDetails);
}
